<template>
  <div class="rating">
    <ul class="list">
      <li
        @mouseenter="rate(star, false)"
        @mouseleave="starHover = stars"
        @click="rate(star, true)"
        v-for="star in maxStars"
        :class="{ active: star <= stars }"
        :key="star.stars"
        :id="star"
        class="star"
      >
        <font-awesome-icon
          style="font-size: 2rem"
          v-if="star <= stars"
          icon="star"
        />
        <svg
          v-else
          style="font-size: 2rem"
          aria-hidden="true"
          focusable="false"
          data-prefix="far"
          data-icon="star"
          class="svg-inline--fa fa-star fa-w-18"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
        >
          <path
            fill="currentColor"
            d="M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"
          ></path>
        </svg>
        <!-- <i :class="star <= stars ? 'fas fa-star' : 'far fa-star'"></i> -->
      </li>
    </ul>
    <div v-if="hasCounter" class="info counter">
      <span class="score-rating"><strong>{{ evaluations[starHover - 1] }}</strong></span>
      <!-- <span class="divider">/</span>
      <span class="score-max">{{ maxStars }}</span> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "Rating",
  props: ["grade", "maxStars", "hasCounter"],
  data() {
    return {
      stars: this.grade,
      starHover: this.grade,
      evaluations: ["Muito Ruim", "Ruim", "Bom", "Muito Bom", "Excelente"],
    };
  },
  methods: {
    rate(star, click) {
      if (typeof star === "number" && star <= this.maxStars && star >= 0) {
        this.starHover = star;
        if (click) {
          this.stars = this.stars === star ? star - 1 : star;
          this.$emit("grade", this.stars);
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.rating {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #343a40;
  /* color: #ffe100; */
  background: #f8f9fa;
  /* border-radius: 8px; */
  /* box-shadow: 0 6px 33px rgba(19, 18, 18, 0.09); */
}

.rating .list {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0 10px 0;
  margin: 0px;
}

.rating .list:hover .star {
  color: #ffe100;
}

.rating .list .star {
  margin: 0px;
  padding: 0 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* font-size: 42px; */
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

.rating .list .star:hover ~ .star:not(.active) {
  color: inherit;
}

.rating .list .star:first-child {
  margin-left: 0;
}

.rating .list .star:active {
  color: #343a40;
}

.rating .info {
  height: 10px;
}

</style>